"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfRegulatoryAssessmentDto = instanceOfRegulatoryAssessmentDto;
exports.RegulatoryAssessmentDtoFromJSON = RegulatoryAssessmentDtoFromJSON;
exports.RegulatoryAssessmentDtoFromJSONTyped = RegulatoryAssessmentDtoFromJSONTyped;
exports.RegulatoryAssessmentDtoToJSON = RegulatoryAssessmentDtoToJSON;
exports.RegulatoryAssessmentDtoToJSONTyped = RegulatoryAssessmentDtoToJSONTyped;
const AssessmentStatus_1 = require("./AssessmentStatus");
/**
 * Check if a given object implements the RegulatoryAssessmentDto interface.
 */
function instanceOfRegulatoryAssessmentDto(value) {
    if (!('assessmentId' in value) || value['assessmentId'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('assessmentStatus' in value) || value['assessmentStatus'] === undefined)
        return false;
    return true;
}
function RegulatoryAssessmentDtoFromJSON(json) {
    return RegulatoryAssessmentDtoFromJSONTyped(json, false);
}
function RegulatoryAssessmentDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'assessmentId': json['assessmentId'],
        'name': json['name'],
        'assessmentStatus': (0, AssessmentStatus_1.AssessmentStatusFromJSON)(json['assessmentStatus']),
        'assessmentAttemptExpiresAt': json['assessmentAttemptExpiresAt'] == null ? undefined : (new Date(json['assessmentAttemptExpiresAt'])),
    };
}
function RegulatoryAssessmentDtoToJSON(json) {
    return RegulatoryAssessmentDtoToJSONTyped(json, false);
}
function RegulatoryAssessmentDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'assessmentId': value['assessmentId'],
        'name': value['name'],
        'assessmentStatus': (0, AssessmentStatus_1.AssessmentStatusToJSON)(value['assessmentStatus']),
        'assessmentAttemptExpiresAt': value['assessmentAttemptExpiresAt'] == null ? undefined : ((value['assessmentAttemptExpiresAt']).toISOString()),
    };
}
//# sourceMappingURL=RegulatoryAssessmentDto.js.map